// extracted by css-extract-rspack-plugin
export default {"dropdown":"_f6ed163c","isVisible":"_d33cb933","bodyWrapper":"_1ed3a104"};